import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function ConfigSummary({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="Configuration Summary"
      fullCaption="Time......................[special]..............
      Time Zone.............greenwich..........
      Date......................[special]..............
      Tag.......................0x19, 0x4B..........
      Mass Flow Unit.....gram/s................
      Volume Flow Unit......L/s.......... 
      "
    />
  );
}

export default ConfigSummary;
